import './App.css';
import {ThemeProvider} from 'retro-react';
import MyTheme from './MyTheme';
import { BrowserRouter } from 'react-router-dom';
import Router from './pages/router/Router';


function App() {
  return (
    <>

    <ThemeProvider theme={MyTheme}>
      <BrowserRouter>
        <Router/>
      </BrowserRouter>
    </ThemeProvider>

    </>
   

 
       
  );
}

export default App;
